import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  SectionSafeHiringTips,
  SectionLocations,
  IconBookmark,
} from '../../components';
// import ReactPlayer from 'react-player/vimeo';
import { NamedLink } from '../../components';
import { trailerCategoryUrls } from '../../util/trailerCategoryUrls';

import css from './SafeHiringPage.module.css';
import image from '../../assets/trailer-with-sticker.avif';

const MEDIUM = 768;
const LARGE = 1024;

// const playerHeight = viewportWidth => {
//   if (viewportWidth >= LARGE) {
//     return '100%';
//   }
//   if (viewportWidth >= MEDIUM) {
//     return '250px';
//   }
//   return '250px';
// };

const SafeHiringPage = () => {
  return (
    <StaticPage
      title="Safe trailer hiring tips"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SafeHiringPage',
        description: 'Safe hiring tips for localtrailerhire.com.au',
        name: 'Safe hiring page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.imageContainer}>
            <img src={image} alt="trailer" className={css.croppedImage} />
          </div>
          <div className={css.contentWrapper}>
            <div className={css.contentMain}>
              <h1 className={css.pageTitle}>
                <FormattedMessage id="SafeHiringPage.title" />
              </h1>
              <h2 className={css.subTitle}>
                <FormattedMessage id="SafeHiringPage.subtitle" />
              </h2>

              <div className={css.contentNavWrapper}>
                <h2 className={css.navTitle}>In this guide</h2>
                <nav className={css.contentNav}>
                  <ul className={css.navList}>
                    <li>
                      <IconBookmark className={css.icon} size={'small'} />
                      <a href="#trailerSelection">Choosing a trailer</a>
                    </li>
                    <li>
                      <IconBookmark size={'small'} className={css.icon} />
                      <a href="#pickUp">Safety check at Pick-up</a>
                    </li>
                    <li>
                      <IconBookmark size={'small'} className={css.icon} />
                      <a href="#loading">Loading</a>
                    </li>
                    <li>
                      <IconBookmark size={'small'} className={css.icon} />
                      <a href="#driving">On the road</a>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className={css.safeHiringSection}>
                <p>
                  We want you to have a smooth, safe and secure experience when hiring trailers
                  through Local Trailer Hire. Check out our practical tips below to help you select
                  the right trailer, hitch it securely, and tow it safely.
                </p>
                <p>
                  Trailer owners are happy to help if you have any safety-related questions, so if
                  you are unsure about anything, we recommend contacting the trailer owner. You can
                  find the Contact button on their trailer page or send them a message once you've
                  made a booking.
                </p>
                {/* <h2>How to hitch a trailer to your vehicle</h2>
                <ReactPlayer
                  url="https://vimeo.com/269687356"
                  width="100%"
                  height='250px'
                /> */}
              </div>
              <SectionSafeHiringTips />

              <SectionLocations />
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default SafeHiringPage;
